import { GetFundGvDistribution, getFundGvDistributionAPI } from "api/fund-gv-distribution.api";
import { useQuery } from "react-query";
import { FundGvDistribution } from "types/fund-gv-distribution";

const FUND_FEE_KEY = "fund-gv-distribution";
export const useGetFundGvDistributionQuery = (query: GetFundGvDistribution) => {
  return useQuery<FundGvDistribution>({
    queryKey: [FUND_FEE_KEY, query.distributionId],
    enabled: query.distributionId !== 0 && query.fundAccountId !== 0,
    queryFn: () => getFundGvDistributionAPI(query),
  });
};
